
// 登录
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER_INFO = 'SET_USER_INFO'
export const CMS_CONTENT_LOADING = 'CMS_CONTENT_LOADING'
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS'
export const SET_VIP_STATUS = 'SET_VIP_STATUS'
